<template>
    <div class="driverAuditDetail">
        <el-descriptions title="基本信息" :column="3" border>
            <el-descriptions-item label="手机号码">{{ detailInfo.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="状态">
                <el-tag v-for="item in $const.DRIVERAUDITSTATUS.filter(item => item.value == detailInfo.applyStatus)"
                    :key="item.value" :type="item.type">{{ item.label }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="机构名称">{{ organizationName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="注册时间">{{ detailInfo.created | filterTime }}</el-descriptions-item>
            <el-descriptions-item label="认证时间">{{ detailInfo.applyTime | filterTime }}</el-descriptions-item>
            <el-descriptions-item label="审核时间">{{ detailInfo.auditTime | filterTime }}</el-descriptions-item>
        </el-descriptions>

        <el-divider></el-divider>

        <div class="audit-info">
            <div class="audit-info-container">
                <div class="audit-menu scrollBar-custom">
                    <div v-for="(item, index) in menuItems" :key="index" :class="{ active: activeMenu === item.key }"
                        @click="scrollToSection(item.key)">
                        {{ item.label }}
                    </div>
                </div>

                <div class="audit-content" ref="auditContent">
                    <div id="idCard" class="section">
                        <div class="formTitle">身份证</div>
                        <div class="image-container">
                            <div class="image-box">
                                <div class="image-preview">
                                    <el-image :src="currentIdCardImage" alt="身份证正面照片" style="width: 380px; height: 240px;" fit="cover"
                                        :preview-src-list="[currentIdCardImage]" v-if="currentIdCardImage"></el-image>
                                    <div class="no-image" v-else>暂无图片</div>
                                </div>
                                <div class="button-group">
                                    <el-button :class="{ active: currentIdCardType === 'idCardFrontPath' }"
                                        @click="switchImage('currentIdCardType','idCardFrontPath')">身份证人像面</el-button>
                                    <el-button :class="{ active: currentIdCardType === 'idCardBackPath' }"
                                        @click="switchImage('currentIdCardType','idCardBackPath')">身份证国徽面</el-button>
                                </div>
                            </div>
                            <div class="info-box">
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="到期时间">{{ detailInfo.idCardValid | filterTime('YYYY-MM-DD') }}</el-form-item>
                                    <el-form-item label="姓名">{{ detailInfo.name || '-' }}</el-form-item>
                                    <el-form-item label="性别">{{ detailInfo.gender | filterConst('GENDER')
                                        }}</el-form-item>
                                    <el-form-item label="身份证号">{{ detailInfo.idCard || '-' }}</el-form-item>
                                </el-form>
                                <div class="reason-box" v-if="type == 'audit'">
                                    <div class="reason-title">未通过原因</div>
                                    <el-checkbox-group v-model="idCardReasons">
                                        <el-checkbox v-for="item in idCardReasonList" :key="item.value"
                                            :label="item.label">
                                        </el-checkbox>
                                    </el-checkbox-group>
                                    <el-input v-if="idCardReasons.includes('其他')" v-model="idCardOtherReason"
                                        type="textarea" :rows="2" placeholder="请输入其他原因" class="other-reason"
                                        :status="idCardOtherReason ? '' : 'error'" :maxlength="100">
                                        <template #append>
                                            <span class="required-mark">*</span>
                                        </template>
                                    </el-input>
                                </div>
                                <div class="reason-box" v-else>
                                    <div :style="{ color: detailInfo.idCardApplyStatus == 3 ? '#67c23a' : '#F00' }">{{
                                        detailInfo.idCardApplyStatus == 3
                                            ? '审核通过' : '未通过' }}</div>
                                    <div class="reason-box-detail" v-if="detailInfo.idCardApplyStatus == 4">{{
                                        detailInfo.idCardRefusalReason ||
                                        '-' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="driverLicense" class="section">
                        <div class="formTitle">驾驶证</div>
                        <div class="image-container">
                            <div class="image-box">
                                <div class="image-preview">
                                    <el-image :src="currentDriverLicenseImage" alt="驾驶证正面照片" style="width: 380px; height: 240px;" fit="cover"
                                        :preview-src-list="[currentDriverLicenseImage]"
                                        v-if="currentDriverLicenseImage"></el-image>
                                    <div class="no-image" v-else>暂无图片</div>
                                </div>
                                <div class="button-group">
                                    <el-button :class="{ active: currentDriverLicenseType === 'driverLicensePath' }"
                                        @click="switchImage('currentDriverLicenseType', 'driverLicensePath')">驾驶证正页</el-button>
                                    <el-button :class="{ active: currentDriverLicenseType === 'driverLicenseBackPath' }"
                                        @click="switchImage('currentDriverLicenseType', 'driverLicenseBackPath')">驾驶证副页</el-button>
                                </div>
                            </div>
                            <div class="info-box">
                                <el-form label-width="120px" label-position="left">
                                    <el-form-item label="准驾车型">{{ detailInfo.driverClass || '-' }}</el-form-item>
                                    <el-form-item label="初次领证日期">{{ detailInfo.firstIssueDate | filterTime('YYYY-MM-DD')
                                        }}</el-form-item>
                                    <el-form-item label="到期时间">{{ detailInfo.driverLicenceValid | filterTime('YYYY-MM-DD')
                                        }}</el-form-item>
                                </el-form>
                                <div class="reason-box" v-if="type == 'audit'">
                                    <div class="reason-title">未通过原因</div>
                                    <el-checkbox-group v-model="driverLicenseReasons">
                                        <el-checkbox v-for="item in driverLicenseReasonList" :key="item.value"
                                            :label="item.label">
                                        </el-checkbox>
                                    </el-checkbox-group>
                                    <el-input v-if="driverLicenseReasons.includes('其他')"
                                        v-model="driverLicenseOtherReason" type="textarea" :rows="2"
                                        placeholder="请输入其他原因" class="other-reason"
                                        :status="driverLicenseOtherReason ? '' : 'error'" :maxlength="100">
                                        <template #append>
                                            <span class="required-mark">*</span>
                                        </template>
                                    </el-input>
                                </div>
                                <div class="reason-box" v-else>
                                    <div
                                        :style="{ color: detailInfo.driverLicenceApplyStatus == 3 ? '#67c23a' : '#F00' }">
                                        {{
                                            detailInfo.driverLicenceApplyStatus == 3 ? '审核通过' : '未通过' }}</div>
                                    <div class="reason-box-detail" v-if="detailInfo.driverLicenceApplyStatus == 4">{{
                                        detailInfo.driverLicenceRefusalReason || '-' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="qualification" class="section">
                        <div class="formTitle">从业资格证</div>
                        <div class="image-container">
                            <div class="image-box">
                                <div class="image-preview">
                                    <el-image :src="currentQualificationImage" alt="从业资格证照片" style="width: 380px; height: 240px;" fit="cover"
                                        :preview-src-list="[currentQualificationImage]"
                                        v-if="currentQualificationImage"></el-image>
                                    <div class="no-image" v-else>暂无图片</div>
                                </div>
                                <div class="button-group">
                                    <el-button :class="{ active: currentQualificationType === 'qualificationsPath' }"
                                        @click="switchImage('currentQualificationType', 'qualificationsPath')">从业资格证</el-button>
                                </div>
                            </div>
                            <div class="info-box">
                                <el-form label-width="120px" label-position="left">
                                    <!-- <el-form-item label="证件编号">{{ detailInfo.qualificationsNo || '-' }}</el-form-item>
                                    <el-form-item label="到期时间">{{ detailInfo.qualificationsValid | filterTime
                                        }}</el-form-item> -->
                                </el-form>
                                <div class="reason-box" v-if="type == 'audit'">
                                    <div class="reason-title">未通过原因</div>
                                    <el-checkbox-group v-model="qualificationReasons">
                                        <el-checkbox v-for="item in qualificationReasonList" :key="item.value"
                                            :label="item.label">
                                        </el-checkbox>
                                    </el-checkbox-group>
                                    <el-input v-if="qualificationReasons.includes('其他')"
                                        v-model="qualificationOtherReason" type="textarea" :rows="2"
                                        placeholder="请输入其他原因" class="other-reason"
                                        :status="qualificationOtherReason ? '' : 'error'" :maxlength="100">
                                        <template #append>
                                            <span class="required-mark">*</span>
                                        </template>
                                    </el-input>
                                </div>
                                <div class="reason-box" v-else>
                                    <div
                                        :style="{ color: detailInfo.qualificationsApplyStatus == 3 ? '#67c23a' : '#F00' }">
                                        {{
                                            detailInfo.qualificationsApplyStatus == 3 ? '审核通过' : '未通过' }}</div>
                                    <div class="reason-box-detail" v-if="detailInfo.qualificationsApplyStatus == 4">{{
                                        detailInfo.qualificationsRefusalReason || '-'
                                    }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="detailInfo.hasVehicle == 1">
                        <div id="vehicleLicense" class="section">
                            <div class="formTitle">行驶证</div>
                            <div class="image-container">
                                <div class="image-box">
                                    <div class="image-preview">
                                        <el-image :src="currentVehicleLicenseImage" alt="行驶证照片" style="width: 380px; height: 240px;" fit="cover"
                                            :preview-src-list="[currentVehicleLicenseImage]"
                                            v-if="currentVehicleLicenseImage"></el-image>
                                        <div class="no-image" v-else>暂无图片</div>
                                    </div>
                                    <div class="button-group">
                                        <el-button
                                            :class="{ active: currentVehicleLicenseType === 'drivingLicenseFront' }"
                                            @click="switchImage('currentVehicleLicenseType','drivingLicenseFront')">行驶证正页</el-button>
                                        <el-button
                                            :class="{ active: currentVehicleLicenseType === 'drivingLicenseBack' }"
                                            @click="switchImage('currentVehicleLicenseType','drivingLicenseBack')">行驶证副页</el-button>
                                    </div>
                                </div>
                                <div class="info-box">
                                    <el-form label-width="120px" label-position="left">
                                        <el-form-item label="车辆识别代号">{{ detailInfo.vin || '-' }}</el-form-item>
                                        <el-form-item label="车辆号牌">
                                            <span v-if="detailInfo.licenseNo" :style="getPlateStyle(detailInfo.licenseNo)">{{ formatPlateNumber(detailInfo.licenseNo) }}</span>
                                            <span v-else>-</span>
                                        </el-form-item>
                                        <el-form-item label="使用性质">{{ detailInfo.useCharacter || '-' }}</el-form-item>
                                        <el-form-item label="核载人数">{{ detailInfo.vehicleSeat || '-' }}</el-form-item>
                                        <el-form-item label="注册日期">{{ detailInfo.registerDate | filterTime('YYYY-MM-DD')
                                            }}</el-form-item>
                                    </el-form>
                                    <div class="reason-box" v-if="type == 'audit'">
                                        <div class="reason-title">未通过原因</div>
                                        <el-checkbox-group v-model="vehicleLicenseReasons">
                                            <el-checkbox v-for="item in vehicleLicenseReasonList" :key="item.value"
                                                :label="item.label">
                                            </el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-if="vehicleLicenseReasons.includes('其他')"
                                            v-model="vehicleLicenseOtherReason" type="textarea" :rows="2"
                                            placeholder="请输入其他原因" class="other-reason"
                                            :status="vehicleLicenseOtherReason ? '' : 'error'" :maxlength="100">
                                            <template #append>
                                                <span class="required-mark">*</span>
                                            </template>
                                        </el-input>
                                    </div>
                                    <div class="reason-box" v-else>
                                        <div
                                            :style="{ color: detailInfo.drivingLicenseApplyStatus == 3 ? '#67c23a' : '#F00' }">
                                            {{ detailInfo.drivingLicenseApplyStatus == 3 ? '审核通过' : '未通过' }}</div>
                                        <div class="reason-box-detail" v-if="detailInfo.drivingLicenseApplyStatus == 4">
                                            {{ detailInfo.drivingLicenseRefusalReason || '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="roadTransport" class="section">
                            <div class="formTitle">道路运输证</div>
                            <div class="image-container">
                                <div class="image-box">
                                    <div class="image-preview">
                                        <el-image :src="currentRoadTransportImage" alt="道路运输证照片" style="width: 380px; height: 240px;" fit="cover"
                                            :preview-src-list="[currentRoadTransportImage]"
                                            v-if="currentRoadTransportImage"></el-image>
                                        <div class="no-image" v-else>暂无图片</div>
                                    </div>
                                    <div class="button-group">
                                        <el-button :class="{ active: currentRoadTransportType === 'roadTransportCertificate' }"
                                            @click="switchImage('currentRoadTransportType','roadTransportCertificate')">道路运输证</el-button>
                                    </div>
                                </div>
                                <div class="info-box">
                                    <el-form label-width="120px" label-position="left">
                                        <!-- <el-form-item label="证件编号">{{ detailInfo.roadTransportCertificateNo || '-'
                                            }}</el-form-item>
                                        <el-form-item label="到期时间">{{ detailInfo.roadTransportCertificateValid | filterTime
                                            }}</el-form-item> -->
                                    </el-form>
                                    <div class="reason-box" v-if="type == 'audit'">
                                        <div class="reason-title">未通过原因</div>
                                        <el-checkbox-group v-model="roadTransportReasons">
                                            <el-checkbox v-for="item in roadTransportReasonList" :key="item.value"
                                                :label="item.label">
                                            </el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-if="roadTransportReasons.includes('其他')"
                                            v-model="roadTransportOtherReason" type="textarea" :rows="2"
                                            placeholder="请输入其他原因" class="other-reason"
                                            :status="roadTransportOtherReason ? '' : 'error'" :maxlength="100">
                                            <template #append>
                                                <span class="required-mark">*</span>
                                            </template>
                                        </el-input>
                                    </div>
                                    <div class="reason-box" v-else>
                                        <div
                                            :style="{ color: detailInfo.roadTransportCertificateApplyStatus == 3 ? '#67c23a' : '#F00' }">
                                            {{ detailInfo.roadTransportCertificateApplyStatus == 3 ? '审核通过' : '未通过' }}</div>
                                        <div class="reason-box-detail" v-if="detailInfo.roadTransportCertificateApplyStatus == 4">
                                            {{ detailInfo.roadTransportCertificateRefusalReason || '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="vehiclePhoto" class="section">
                            <div class="formTitle">车辆照片</div>
                            <div class="image-container">
                                <div class="image-box">
                                    <div class="image-preview">
                                        <el-image :src="currentVehiclePhotoImage" alt="车辆照片" style="width: 380px; height: 240px;" fit="cover"
                                            :preview-src-list="[currentVehiclePhotoImage]"
                                            v-if="currentVehiclePhotoImage"></el-image>
                                        <div class="no-image" v-else>暂无图片</div>
                                    </div>
                                    <div class="button-group">
                                        <el-button :class="{ active: currentVehiclePhotoType === 'vehiclePhoto' }"
                                            @click="switchImage('currentVehiclePhotoType','vehiclePhoto')">车辆照片</el-button>
                                    </div>
                                </div>
                                <div class="info-box">
                                    <el-form label-width="120px" label-position="left">
                                        <el-form-item label="车辆型号">{{ detailInfo.vehicleModel || '-' }}</el-form-item>
                                        <el-form-item label="车身颜色">{{ detailInfo.vehicleColor || '-' }}</el-form-item>
                                    </el-form>
                                    <div class="reason-box" v-if="type == 'audit'">
                                        <div class="reason-title">未通过原因</div>
                                        <el-checkbox-group v-model="vehiclePhotoReasons">
                                            <el-checkbox v-for="item in vehiclePhotoReasonList" :key="item.value"
                                                :label="item.label">
                                            </el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-if="vehiclePhotoReasons.includes('其他')"
                                            v-model="vehiclePhotoOtherReason" type="textarea" :rows="2"
                                            placeholder="请输入其他原因" class="other-reason"
                                            :status="vehiclePhotoOtherReason ? '' : 'error'" :maxlength="100">
                                            <template #append>
                                                <span class="required-mark">*</span>
                                            </template>
                                        </el-input>
                                    </div>
                                    <div class="reason-box" v-else>
                                        <div
                                            :style="{ color: detailInfo.vehiclePhotoApplyStatus == 3 ? '#67c23a' : '#F00' }">
                                            {{ detailInfo.vehiclePhotoApplyStatus == 3 ? '审核通过' : '未通过' }}</div>
                                        <div class="reason-box-detail" v-if="detailInfo.vehiclePhotoApplyStatus == 4">
                                            {{ detailInfo.vehiclePhotoRefusalReason || '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="audit-footer" v-if="type == 'audit'">
            <div>
                <el-button type="primary" @click="handleSubmit" :loading="loading">{{ isNoReason ? '审核通过' : '审核驳回' }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            id: this.$route.query.id,
            type: this.$route.query.type,
            organizationName: '',
            detailInfo: {},
            activeMenu: 'idCard',
            menuItems: [
                { hasVehicle: 0, key: 'idCard', label: '身份证' },
                { hasVehicle: 0, key: 'driverLicense', label: '驾驶证' },
                { hasVehicle: 0, key: 'qualification', label: '从业资格证' },
                { hasVehicle: 1, key: 'vehicleLicense', label: '行驶证' },
                { hasVehicle: 1, key: 'roadTransport', label: '道路运输证' },
                { hasVehicle: 1, key: 'vehiclePhoto', label: '车辆照片' }
            ],
            idCardReasonList: [
                { label: '证件信息与证件照片不一致', value: '证件信息与证件照片不一致' },
                { label: '身份证人像面照片不清晰', value: '身份证人像面照片不清晰' },
                { label: '身份证国徽面照片不清晰', value: '身份证国徽面照片不清晰' },
                { label: '请上传身份证人像面照片', value: '请上传身份证人像面照片' },
                { label: '请上传身份证国徽面照片', value: '请上传身份证国徽面照片' },
                { label: '证件已过有效期', value: '证件已过有效期' },
                { label: '其他', value: '其他' },
            ],
            driverLicenseReasonList: [
                { label: '证件信息与证件照片不一致', value: '证件信息与证件照片不一致' },
                { label: '驾驶证正页照片不清晰', value: '驾驶证正页照片不清晰' },
                { label: '驾驶证副页照片不清晰', value: '驾驶证副页照片不清晰' },
                { label: '请上传驾驶证正页照片', value: '请上传驾驶证正页照片' },
                { label: '请上传驾驶证副页照片', value: '请上传驾驶证副页照片' },
                { label: '证件已过有效期', value: '证件已过有效期' },
                { label: '其他', value: '其他' },
            ],
            qualificationReasonList: [
                // { label: '证件信息与证件照片不一致', value: '证件信息与证件照片不一致' },
                { label: '证件照片不清晰', value: '证件照片不清晰' },
                { label: '请上传从业资格证照片', value: '请上传从业资格证照片' },
                { label: '证件已过有效期', value: '证件已过有效期' },
                { label: '其他', value: '其他' },
            ],
            vehicleLicenseReasonList: [
                { label: '证件信息与证件照片不一致', value: '证件信息与证件照片不一致' },
                { label: '行驶证正页照片不清晰', value: '行驶证正页照片不清晰' },
                { label: '行驶证副页照片不清晰', value: '行驶证副页照片不清晰' },
                { label: '请上传行驶证正页照片', value: '请上传行驶证正页照片' },
                { label: '请上传行驶证副页照片', value: '请上传行驶证副页照片' },
                { label: '证件已过有效期', value: '证件已过有效期' },
                { label: '其他', value: '其他' },
            ],
            roadTransportReasonList: [
                // { label: '证件信息与证件照片不一致', value: '证件信息与证件照片不一致' },
                { label: '道路运输证照片不清晰', value: '道路运输证照片不清晰' },
                { label: '请上传道路运输证正页照片', value: '请上传道路运输证正页照片' },
                { label: '证件已过有效期', value: '证件已过有效期' },
                { label: '其他', value: '其他' },
            ],
            vehiclePhotoReasonList: [
                { label: '车辆照片与行驶证信息不一致', value: '车辆照片与行驶证信息不一致' },
                { label: '车辆照片不清晰', value: '车辆照片不清晰' },
                { label: '请上传车辆前45°照片', value: '请上传车辆前45°照片' },
                { label: '其他', value: '其他' },
            ],
            // 身份证图片
            currentIdCardType: 'idCardFrontPath',
            // 驾驶证图片
            currentDriverLicenseType: 'driverLicensePath',
            // 从业资格证图片
            currentQualificationType: 'qualificationsPath',
            // 行驶证图片
            currentVehicleLicenseType: 'drivingLicenseFront',
            // 道路运输证图片
            currentRoadTransportType: 'roadTransportCertificate',
            // 车辆照片
            currentVehiclePhotoType: 'vehiclePhoto',
            // 审核原因
            idCardReasons: [],
            driverLicenseReasons: [],
            qualificationReasons: [],
            vehicleLicenseReasons: [],
            roadTransportReasons: [],
            vehiclePhotoReasons: [],
            // 其他原因
            idCardOtherReason: '',
            driverLicenseOtherReason: '',
            qualificationOtherReason: '',
            vehicleLicenseOtherReason: '',
            roadTransportOtherReason: '',
            vehiclePhotoOtherReason: ''
        }
    },
    computed: {
        currentIdCardImage() {
            return this.mixinQiniuImg(this.detailInfo[this.currentIdCardType])
        },
        currentDriverLicenseImage() {
            return this.mixinQiniuImg(this.detailInfo[this.currentDriverLicenseType])
        },
        currentQualificationImage() {
            return this.mixinQiniuImg(this.detailInfo[this.currentQualificationType])
        },
        currentVehicleLicenseImage() {
            return this.mixinQiniuImg(this.detailInfo[this.currentVehicleLicenseType])
        },
        currentRoadTransportImage() {
            return this.mixinQiniuImg(this.detailInfo[this.currentRoadTransportType])
        },
        currentVehiclePhotoImage() {
            return this.mixinQiniuImg(this.detailInfo[this.currentVehiclePhotoType])
        },
        
        isValid() {  // 其他必填校验
            if (this.idCardReasons.includes('其他') && !this.idCardOtherReason) {
                return false;
            }
            if (this.driverLicenseReasons.includes('其他') && !this.driverLicenseOtherReason) {
                return false;
            }
            if (this.qualificationReasons.includes('其他') && !this.qualificationOtherReason) {
                return false;
            }
            if (this.vehicleLicenseReasons.includes('其他') && !this.vehicleLicenseOtherReason) {
                return false;
            }
            if (this.roadTransportReasons.includes('其他') && !this.roadTransportOtherReason) {
                return false;
            }
            if (this.vehiclePhotoReasons.includes('其他') && !this.vehiclePhotoOtherReason) {
                return false;
            }
            return true;
        },
        
        isNoReason() {  // 如果所有原因都为空，则为通过，否则为驳回
            return this.idCardReasons.length == 0 && this.driverLicenseReasons.length == 0 && this.qualificationReasons.length == 0 &&
                this.vehicleLicenseReasons.length == 0 && this.roadTransportReasons.length == 0 && this.vehiclePhotoReasons.length == 0
        }
    },
    watch: {
        idCardReasons(newVal) {
            if (!newVal.includes('其他')) {
                this.idCardOtherReason = '';
            }
        },
        driverLicenseReasons(newVal) {
            if (!newVal.includes('其他')) {
                this.driverLicenseOtherReason = '';
            }
        },
        qualificationReasons(newVal) {
            if (!newVal.includes('其他')) {
                this.qualificationOtherReason = '';
            }
        },
        vehicleLicenseReasons(newVal) {
            if (!newVal.includes('其他')) {
                this.vehicleLicenseOtherReason = '';
            }
        },
        roadTransportReasons(newVal) {
            if (!newVal.includes('其他')) {
                this.roadTransportOtherReason = '';
            }
        },
        vehiclePhotoReasons(newVal) {
            if (!newVal.includes('其他')) {
                this.vehiclePhotoOtherReason = '';
            }
        }
    },
    created() {
        this.getInfo()
    },
    mounted() {
        const container = this.$refs.auditContent;
        container.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        const container = this.$refs.auditContent;
        container.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 获取详细信息    
        async getInfo() {
            let url = `/api/v1/manage/driver/audit/${this.id}`
            let { code, data } = await this.$axios.get(url)
            if (code === 1) {
                this.detailInfo = data
                this.organizationName = await this.getOrgName(data.organizationId)
                if(!data.hasVehicle){
                    this.menuItems = this.menuItems.filter(item => item.hasVehicle == 0)
                }
            }
        },
        scrollToSection(key) {
            this.activeMenu = key;
            const element = document.getElementById(key);
            if (element) {
                const container = this.$refs.auditContent;
                const containerRect = container.getBoundingClientRect();
                const elementRect = element.getBoundingClientRect();
                const scrollTop = elementRect.top - containerRect.top + container.scrollTop - 20;

                container.scrollTo({
                    top: scrollTop,
                    behavior: 'smooth'
                });
            }
        },
        handleScroll() {
            const container = this.$refs.auditContent;
            const sections = ['idCard', 'driverLicense', 'qualification', 'vehicleLicense', 'roadTransport', 'vehiclePhoto'];
            const containerRect = container.getBoundingClientRect();

            // 找到当前视口中最靠近顶部的section
            let closestSection = sections[0];
            let minDistance = Infinity;

            sections.forEach(sectionId => {
                const element = document.getElementById(sectionId);
                if (element) {
                    const elementRect = element.getBoundingClientRect();
                    const distance = Math.abs(elementRect.top - containerRect.top);
                    if (distance < minDistance) {
                        minDistance = distance;
                        closestSection = sectionId;
                    }
                }
            });

            this.activeMenu = closestSection;
        },
        switchImage(type, key) {
            this[type] = key;
        },
        getParams() {
            let reason = ""
            if (this.idCardReasons.length > 0) {
                let reasons = this.idCardReasons.filter(item => item !== '其他')
                reason += '身份证：' + (this.idCardReasons.includes('其他') ? [...reasons, this.idCardOtherReason].join(',') : reasons.join(',')) + '。'
            }
            if (this.driverLicenseReasons.length > 0) {
                let reasons = this.driverLicenseReasons.filter(item => item !== '其他')
                reason += '驾驶证：' + (this.driverLicenseReasons.includes('其他') ? [...reasons, this.driverLicenseOtherReason].join(',') : reasons.join(',')) + '。'
            }
            if (this.qualificationReasons.length > 0) {
                let reasons = this.qualificationReasons.filter(item => item !== '其他')
                reason += '从业资格证：' + (this.qualificationReasons.includes('其他') ? [...reasons, this.qualificationOtherReason].join(',') : reasons.join(',')) + '。'
            }
            if (this.vehicleLicenseReasons.length > 0) {
                let reasons = this.vehicleLicenseReasons.filter(item => item !== '其他')
                reason += '行驶证：' + (this.vehicleLicenseReasons.includes('其他') ? [...reasons, this.vehicleLicenseOtherReason].join(',') : reasons.join(',')) + '。'
            }
            if (this.roadTransportReasons.length > 0) {
                let reasons = this.roadTransportReasons.filter(item => item !== '其他')
                reason += '道路运输证：' + (this.roadTransportReasons.includes('其他') ? [...reasons, this.roadTransportOtherReason].join(',') : reasons.join(',')) + '。'
            }
            if (this.vehiclePhotoReasons.length > 0) {
                let reasons = this.vehiclePhotoReasons.filter(item => item !== '其他')
                reason += '车辆照片：' + (this.vehiclePhotoReasons.includes('其他') ? [...reasons, this.vehiclePhotoOtherReason].join(',') : reasons.join(',')) + '。'
            }
            let applyStatus = this.isNoReason ? 3 : 4

            // 如果包含其他，需要去除其他，显示输入框的值
            let idCardReasons = this.idCardReasons.filter(item => item !== '其他')
            let idCardRefusalReason = this.idCardReasons.includes('其他') ? [...idCardReasons, this.idCardOtherReason].join(',') : idCardReasons.join(',')
            let idCardApplyStatus = this.idCardReasons.length == 0 ? 3 : 4

            let driverLicenseReasons = this.driverLicenseReasons.filter(item => item !== '其他')
            let driverLicenceRefusalReason = this.driverLicenseReasons.includes('其他') ? [...driverLicenseReasons, this.driverLicenseOtherReason].join(',') : driverLicenseReasons.join(',')
            let driverLicenceApplyStatus = this.driverLicenseReasons.length == 0 ? 3 : 4

            let qualificationReasons = this.qualificationReasons.filter(item => item !== '其他')
            let qualificationsRefusalReason = this.qualificationReasons.includes('其他') ? [...qualificationReasons, this.qualificationOtherReason].join(',') : qualificationReasons.join(',')
            let qualificationsApplyStatus = this.qualificationReasons.length == 0 ? 3 : 4

            let vehicleLicenseReasons = this.vehicleLicenseReasons.filter(item => item !== '其他')
            let drivingLicenseRefusalReason = this.vehicleLicenseReasons.includes('其他') ? [...vehicleLicenseReasons, this.vehicleLicenseOtherReason].join(',') : vehicleLicenseReasons.join(',')
            let drivingLicenseApplyStatus = this.vehicleLicenseReasons.length == 0 ? 3 : 4

            let roadTransportReasons = this.roadTransportReasons.filter(item => item !== '其他')
            let roadTransportCertificateRefusalReason = this.roadTransportReasons.includes('其他') ? [...roadTransportReasons, this.roadTransportOtherReason].join(',') : roadTransportReasons.join(',')
            let roadTransportCertificateApplyStatus = this.roadTransportReasons.length == 0 ? 3 : 4

            let vehiclePhotoReasons = this.vehiclePhotoReasons.filter(item => item !== '其他')
            let vehiclePhotoRefusalReason = this.vehiclePhotoReasons.includes('其他') ? [...vehiclePhotoReasons, this.vehiclePhotoOtherReason].join(',') : vehiclePhotoReasons.join(',')
            let vehiclePhotoApplyStatus = this.vehiclePhotoReasons.length == 0 ? 3 : 4

            return {
                id: this.id,
                applyStatus,
                refusalReason: reason,
                idCardApplyStatus, //身份证认证状态（3-通过，4-拒绝）
                idCardRefusalReason, // 身份证拒绝原因
                driverLicenceApplyStatus, // 驾驶证认证状态（3-通过，4-拒绝）
                driverLicenceRefusalReason, // 驾驶证拒绝原因
                qualificationsApplyStatus, // 从业资格证认证状态（3-通过，4-拒绝）
                qualificationsRefusalReason, // 从业资格证拒绝原因
                drivingLicenseApplyStatus, // 行驶证认证状态（3-通过，4-拒绝）
                drivingLicenseRefusalReason, // 行驶证拒绝原因
                roadTransportCertificateApplyStatus, // 道路运输证认证状态（3-通过，4-拒绝）
                roadTransportCertificateRefusalReason, // 道路运输证拒绝原因
                vehiclePhotoApplyStatus, // 车辆照片认证状态（3-通过，4-拒绝）
                vehiclePhotoRefusalReason, // 车辆照片拒绝原因
            };
        },
        async handleSubmit() {
            if (!this.isValid) {
                this.$message.error('请填写选择"其他"的具体原因');
                return;
            }
            this.loading = true
            
            this.$confirm('是否确认提交本次审核结果？', '提交审核结果', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
            }).then(async () => {
                let url = '/api/v1/manage/driver/audit';
                let params = this.getParams()
                let { code } = await this.$axios.put(url, params);
                if (code === 1) {
                    this.$message.success('审核结果提交成功');
                    this.$router.go(-1)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="less" scoped>
.driverAuditDetail {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    // 基本信息描述列表
    :deep(.el-descriptions) {
        background: #fff;
        border-radius: 8px;
        
        .el-descriptions__header {
            margin-bottom: 16px;
            
            .el-descriptions__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }
    }

    :deep(.el-descriptions-item__label) {
        width: 88px;
        font-weight: 500;
        color: #606266;
    }

    :deep(.el-descriptions-item__content) {
        width: 200px;
        color: #303133;

        .el-tag {
            background: none;
            border: 0;
        }
    }

    .audit-info {
        box-sizing: border-box;
        margin: 0 0 16px 0;
        flex: 1;
        overflow-y: hidden;

        .audit-info-container {
            display: flex;
            height: 100%;
            background: #fff;
            border-radius: 8px;

            .audit-menu {
                width: 160px;
                height: 100%;
                flex-shrink: 0;
                border-right: 1px solid #ebeef5;
                overflow-y: auto;
                padding: 8px 0;

                div {
                    padding: 14px 20px;
                    cursor: pointer;
                    transition: all 0.2s;
                    font-size: 14px;
                    color: #606266;
                    border-left: 3px solid transparent;

                    &:hover {
                        background: #f5f7fa;
                        color: #2B77FF;
                    }

                    &.active {
                        color: #2B77FF;
                        background: #f0f7ff;
                        border-left-color: #2B77FF;
                        font-weight: 500;
                    }
                }
            }

            .audit-content {
                flex: 1;
                padding: 20px 24px;
                height: 100%;
                overflow-y: auto;

                .section {
                    margin-bottom: 32px;

                    .formTitle {
                        font-size: 15px;
                        font-weight: 600;
                        color: #303133;
                        margin-bottom: 16px;
                        padding-bottom: 12px;
                        border-bottom: 1px solid #ebeef5;
                    }

                    .image-container {
                        display: flex;
                        gap: 24px;
                        flex-wrap: wrap;

                        .image-box {
                            width: 380px;
                            flex-shrink: 0;

                            .image-preview {
                                border: 1px solid #e4e7ed;
                                border-radius: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-bottom: 12px;
                                overflow: hidden;
                                background: #f5f7fa;
                                min-height: 240px;

                                img {
                                    max-width: 100%;
                                    max-height: 100%;
                                    object-fit: contain;
                                }

                                .no-image {
                                    height: 240px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    color: #c0c4cc;
                                    font-size: 14px;
                                    flex-direction: column;
                                    gap: 8px;
                                    &::before {
                                        content: '\e6a0';
                                        font-family: element-icons;
                                        font-size: 32px;
                                        color: #dcdfe6;
                                    }
                                }
                            }

                            .button-group {
                                display: flex;
                                gap: 8px;
                                flex-wrap: wrap;

                                .el-button {
                                    flex: 1;
                                    min-width: 80px;
                                    border-radius: 6px;
                                    transition: all 0.2s;
                                    font-size: 13px;

                                    &.active {
                                        background-color: #2B77FF;
                                        border-color: #2B77FF;
                                        color: #fff;
                                        box-shadow: 0 2px 8px rgba(43,119,255,0.3);
                                    }
                                }
                            }
                        }

                        .info-box {
                            flex: 1;
                            min-width: 320px;
                            display: flex;
                            flex-direction: column;
                            gap: 0;

                            .el-form {
                                flex: none;
                                
                                :deep(.el-form-item) {
                                    margin-bottom: 12px;
                                }

                                :deep(.el-form-item__label) {
                                    font-weight: 500;
                                    color: #606266;
                                }
                                
                                :deep(.el-form-item__content) {
                                    color: #303133;
                                    font-weight: 500;
                                }
                            }

                            .reason-box {
                                margin-top: 16px;
                                border-top: 1px solid #ebeef5;
                                padding-top: 16px;

                                .reason-title {
                                    font-size: 14px;
                                    font-weight: 600;
                                    color: #303133;
                                    margin-bottom: 12px;
                                    display: flex;
                                    align-items: center;
                                    gap: 6px;
                                    &::before {
                                        content: '';
                                        display: inline-block;
                                        width: 3px;
                                        height: 14px;
                                        background: #e6a23c;
                                        border-radius: 2px;
                                    }
                                }

                                :deep(.el-checkbox-group) {
                                    display: grid;
                                    grid-template-columns: 1fr 1fr;
                                    gap: 10px 16px;
                                    
                                    .el-checkbox__label {
                                        font-size: 13px;
                                        color: #606266;
                                    }

                                    .el-checkbox {
                                        margin-right: 0;
                                    }
                                }

                                .other-reason {
                                    margin-top: 12px;

                                    :deep(.el-textarea__inner) {
                                        border-radius: 6px;
                                        font-size: 13px;
                                    }

                                    .required-mark {
                                        color: #f56c6c;
                                        margin-left: 4px;
                                    }
                                }

                                .reason-box-detail {
                                    margin-top: 8px;
                                    padding: 10px 14px;
                                    background: #fff8f0;
                                    border: 1px solid #ffd8a8;
                                    border-radius: 6px;
                                    font-size: 13px;
                                    color: #e6a23c;
                                    line-height: 1.6;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .audit-footer {
        display: flex;
        justify-content: flex-end;
        padding: 16px 0;
        border-top: 1px solid #ebeef5;
        background: #fff;
        margin: 0 -20px -20px;
        padding: 16px 24px;
        border-radius: 0 0 8px 8px;
        
        .el-button {
            min-width: 120px;
            border-radius: 6px;
        }
    }
}
</style>